/** Cookie name for the operator's active workspace (a UI selector only; the
 * backend re-checks membership on every request). */
export const ACTIVE_CUSTOMER_COOKIE = "v2_active_customer";

/** Read the active workspace id from `document.cookie`, or null. */
export function readActiveCustomerFromDocument(): string | null {
  if (typeof document === "undefined") return null;
  const prefix = `${ACTIVE_CUSTOMER_COOKIE}=`;
  for (const part of document.cookie.split("; ")) {
    if (part.startsWith(prefix)) {
      const value = part.slice(prefix.length);
      return value ? decodeURIComponent(value) : null;
    }
  }
  return null;
}

/** Persist the active workspace id for a year. */
export function writeActiveCustomerCookie(id: string): void {
  if (typeof document === "undefined") return;
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${ACTIVE_CUSTOMER_COOKIE}=${encodeURIComponent(id)}; Path=/; Max-Age=${60 * 60 * 24 * 365}; SameSite=Lax${secure}`;
}
